/* eslint-disabled */
import Question from "./Question";
import Tag from "./Tag";
import QuestionTypeExtend from "@/entity/extends/QuestionTypeExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class QuestionType extends QuestionTypeExtend {

public id!: number;
public label = '';
public code = '';
public class? = '';
public questions: Array<Question> = [];
public tags: Array<Tag> = [];

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
       this.code= object.code;
       this.class= object.class;
       hydrateCollection(object.questions, Question, this.questions);
       hydrateCollection(object.tags, Tag, this.tags);
      }
  }

}
